/* =========================================
   MEXA PRODUCT ADD-ON
========================================= */

document.addEventListener('click', async function (event) {
  const button = event.target.closest('.mexa-addon-add');

  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;

  try {
    /* Bloquear mientras agrega */
    button.disabled = true;
    button.classList.add('is-adding');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add product');
    }

    /* Agregado correctamente */
    button.classList.remove('is-adding');
    button.classList.add('is-added');

    /* Check boutique verde */
    button.textContent = '✓';
    button.style.color = '#256040';
    button.style.fontWeight = '700';
    button.style.fontSize = '25px';

    /* Ir al carrito */
    setTimeout(() => {
      window.location.href = '/cart';
    }, 1000);

  } catch (error) {
    console.error(error);

    /* Si falla, regresar al + rojo */
    button.disabled = false;
    button.classList.remove('is-adding', 'is-added');
    button.textContent = '+';
    button.style.color = '#B90000';
    button.style.fontWeight = '';
    button.style.fontSize = '';
  }
});